<template>
  <div class="header_container">
    <span style="float: left;">
      <img :src="indexPageUrl" width="100px" height="50px" usemap="#planetmap" />
      <map name="planetmap">
        <area shape="rect" coords="14,2,35,15" @click="putColor(pink)" :title="$t('lang.lab_pinkType')"
          style="cursor: pointer;" />
        <area shape="rect" coords="3,12,16,29" @click="putColor(green)" :title="$t('lang.lab_greenType')"
          style="cursor: pointer;" />
        <area shape="rect" coords="20,22,37,34" @click="putColor(blue_green)" :title="$t('lang.lab_blueType')"
          style="cursor: pointer;" />
      </map>
    </span>
    <swiperFont :lists="fontLists"></swiperFont>
    <span style="float: right;" class="rightPostiton click4">
      <i class="el-icon-full-screen fullScreen" title="全屏" @click="fullScreen()" v-if="allScreen === 1"></i>
      <i class="el-icon-full-screen fullScreen" title="退出全屏" @click="exitFullScreen()" v-if="allScreen === 0"></i>
      <!-- <a :href="testpaper + userId" target="_blank" class="rightPostiton click2">{{$t('lang.lab_textText')}}</a> -->
      <a v-if="showBigDataScreen&&showDataV" :href="bigDataScreen" target="_blank" class="rightPostiton"  style="margin-left:20px;">
        <i class="el-icon-s-operation" style="margin-right: 5px;"></i>数据大屏
      </a>
      <!-- <a :href="kanBan + userId" target="_blank" class="rightPostiton click2">
        <i class="el-icon-s-data"></i> {{$t('lang.lab_seeBlock')}}
      </a> -->
      <!-- <a :href="help" target="_blank" class="rightPostiton click2" style="margin-left:0px;">
        <i class="el-icon-question"></i> 平台介绍
      </a> -->

      <i class="el-icon-question" style="margin-left: 20px;"></i>
      <el-dropdown menu-align='start' class="userMessage" style="margin-right:20px;">
        <span class="name" style="font-size:16px;color:#000;margin-left:5px;">帮助文档</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="seeMessage" style="display:inline-block;">
            <a :href="help" target="_blank" class="rightPostiton click2" style="margin-left:0px;color:#606266;">
              <i class="el-icon-question"></i> 平台介绍
            </a>
          </el-dropdown-item>
          <el-dropdown-item command="signout" style="display:inline-block;">
            <div @click="showHelpDialog()">
              <i class="el-icon-s-order"></i> 功能帮助
            </div>
          </el-dropdown-item>
          <el-dropdown-item command="signout" style="display:inline-block;">
            <div @click="showDialog()">
              <i class="el-icon-tickets"></i> 更新日志
            </div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <i class="el-icon-mobile-phone"></i>
      <el-dropdown menu-align='start' class="userMessage" style="margin-right:20px;">
        <span class="name" style="font-size:16px;color:#000;margin-left:5px;">APP二维码</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="seeMessage" style="display:inline-block;">
            <el-image style="width: 160px;"
              src="https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/6b3f7a0c-a6d1-4649-8283-41cb43dd1add.png" fit="fit"></el-image>
          </el-dropdown-item>
          <el-dropdown-item command="signout" style="display:inline-block;">
            <el-image style="width: 160px;"
              src="https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/03/06/648dd154-cb76-4238-83e1-b121e3190f89.png" fit="fit"></el-image>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown @command="handleCommand" menu-align='start' class="userMessage">
        <span class="name">{{$t('lang.lab_userNameId')}}{{user}}</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="seeMessage" v-if="gardenDate">有效期至：{{gardenDate}}</el-dropdown-item>
          <el-dropdown-item command="seeMessage">{{$t('lang.lab_message')}}</el-dropdown-item>
          <el-dropdown-item command="signout"><i class="el-icon-switch-button"></i>{{$t('lang.lab_exit')}}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </span>

    <el-dialog title="版本更新列表" :visible.sync="dialogVisible" width="60%">
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="title" label="版本号"></el-table-column>
        <el-table-column prop="createTime" label="更新时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="operation" label="更新详情" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">更新详情</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-dialog>
    <el-dialog title="功能帮助" :visible.sync="dialogVisible1" width="60%">
      <el-table :data="tableData1"
        :height="tableData1.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName">
        <el-table-column type="index" :index="indexMethod1" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="name" label="功能简介">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.name&&scope.row.name.length> require('@/config/enum').tableDatamaxlength60"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.name }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.name.substring(0, require('@/config/enum').tableDatamaxlength60) | valueIsNull }}
                <span v-if="scope.row.name.length>require('@/config/enum').tableDatamaxlength60">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.name | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="Url" label="操作" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <a :href="scope.row.Url" target="_blank">详情</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page="pageNo1"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize1" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount1" />
    </el-dialog>
  </div>
</template>

<script>
  import swiperFont from './swiperFont'
  import {
    changeThemeColor
  } from '@/config/themeColorClient'
  import {
    mapGetters
  } from 'vuex'

  export default {
    components: {
      swiperFont
    },
    data() {
      return {
        lang: 'zh-CN',
        testpaper: 'http://101.37.66.148/exam/#/admin?userid=',
        kanBan: 'http://admin.zlj365.com:8081/taskboard/kanban.html?userid=',
        help: 'https://alidocs.dingtalk.com/i/p/b0KrwmPpO3gm79nv5eGeggbYQKvYvX3N',
        blue_green: {
          top: '#00b1c3',
          bottom: '#006d9a'
        },
        pink: {
          top: '#ed8599',
          bottom: '#c84b71'
        },
        green: {
          top: '#b4d049',
          bottom: '#4ea00b'
        },
        show: false,
        allScreen: 1,
        tableData: [], // list
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        dialogVisible: false,
        dialogVisible1: false,
        tableData1: [], // list
        pageNo1: 1, // 页数
        pageSize1: 10, // 每页显示数量
        pageCount1: 0, // 总页数
        fontLists: [],
        gardenDate: '', // 小区有效期
        indexPageUrl: 'http://oss.kmyhwy.cn/2025/04/15/7282b8af-2afa-4e0b-b1ab-74572b2a1fc3.png', // 左上角logo
        bigDataScreen: '', // 数据大屏地址
        showBigDataScreen: false, // 数据大屏显示状态
        showDataV: false, // 数据大屏显示状态

      }
    },
    computed: {
      ...mapGetters({
        user: 'nickName',
        userId: 'staffId',
        gardenId: 'gardenId',
        userGardenList: 'userGardenList'
      }),
      gardenId1() {
        return this.gardenId
      },
    },
    watch: {
      gardenId1(newData, oldData) {
        this.getDate(newData)
        this.getLogoUrl(newData)
        this.getGardenAddress(newData)
      }
    },
    created() {
      this.getDate(this.gardenId)
      this.getVersion()
      this.getHelpList()
      this.getLogoUrl(this.gardenId)
      this.getGardenAddress(this.gardenId)
      this.getBigDataScreen()
    },
    methods: {
      // 获取项目到期时间
      getDate(newData) {
        if (newData == 0) {
          this.gardenDate = ''
        } else {
          var obj = this.userGardenList.find(function (obj) {
            return obj.id == newData
          })
          if (obj.gardenValid) {
            this.gardenDate = obj.gardenValid
          } else {
            this.gardenDate = ''
          }
        }
      },
      // 异步函数，原理为promise
      async handleCommand(command) {
        switch (command) {
          case 'home':
            this.$router.push('/manage')
            break
          case 'signout':
            this.$store.commit('user/emptyUserData')
            this.$router.push({
              name: 'login'
            })
            break
          case 'changeLangEvent':
            this.lang = this.lang === 'zh-CN' ? 'en-US' : 'zh-CN'
            this.$i18n.locale = this.lang // 关键语句
            break
          case 'seeMessage':
            this.$router.push('/manage/personalInfo')
            break
          default:
            break
        }
      },
      // 全屏
      fullScreen() {
        this.allScreen = 0
        var el = document.documentElement
        var rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el
          .msRequestFullscreen
        if (typeof rfs != 'undefined' && rfs) {
          rfs.call(el)
        }
      },
      exitFullScreen() {
        this.allScreen = 1
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      },
      // 保存主题至远程服务器
      putColor(theme) {
        // let params = {
        //   style: theme.top + ',' + theme.bottom,
        //   staffId: this.userId
        // }
        // this.$patch(`/admins/style`, params).then(
        //   res => {
        //     if (res && res.errCode === 0) {
        //       changeThemeColor(theme.top)
        //         .then(() => {
        //           console.log('主题色切换成功~')
        //           this.$store.commit('theme/setTheme', theme)
        //           this.$message.success('换肤成功～')
        //         })
        //     }
        //   },
        //   error => {
        //     this.$message.error(error)
        //   }
        // )
      },
      // 显示弹窗 
      showDialog() {
        this.dialogVisible = true
      },
      // 显示帮助文档弹窗 
      showHelpDialog() {
        this.dialogVisible1 = true
      },
      // 获取版本更新数据
      getVersion() {
        let loading = this.$loading()
        let params = {}
        params.platform = 3
        params.pageNo = this.pageNo
        params.pageSize = this.pageSize
        this.$get(`/upgradeWiki`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 获取帮助文档数据
      getHelpList() {
        let loading = this.$loading()
        let params = {}
        params.pageNo = this.pageNo1
        params.pageSize = this.pageSize1
        this.$get(`/getHelpDocuments`, params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData1 = res.list
              this.pageCount1 = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getVersion()
      },
      handleCurrentChange1(val) {
        this.pageNo1 = val
        this.getHelpList()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getVersion()
      },
      handleSizeChange1(val) {
        this.pageNo1 = 1
        this.pageSize1 = val
        this.getHelpList()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      indexMethod1(index) {
        return (this.pageNo1 - 1) * this.pageSize1 + index + 1
      },
      formatDate(row, column) {
        // 获取单元格数据
        let data = row[column.property]
        if (data == null) {
          return '--'
        }
        let dt = new Date(data)
        let yy = dt.getFullYear()
        let mm = (dt.getMonth() + 1) > 9 ? (dt.getMonth() + 1) : '0' + (dt.getMonth() + 1)
        let dd = dt.getDate() > 9 ? dt.getDate() : '0' + dt.getDate()
        return yy + '-' + mm + '-' + dd
      },
      // 获取左上角logo地址
      getLogoUrl(id) {
        console.log(this.$store.getters.userData)
        this.$get(`/groupsByGardenId/` + id).then(
						res => {
              console.log(res)
              if (res.list[0].groupId) {
                this.$store.commit('user/setGroupId', res.list[0].groupId)
                this.$store.commit('user/setEditPreInfoIsUseApprove', res.list[0].editPreInfoIsUseApprove)
              }
              console.log('集团ID===' + this.$store.getters.groupId)
              if (res.list[0].indexPageUrl) {
                this.indexPageUrl = res.list[0].indexPageUrl
              } else {
                this.indexPageUrl = 'https://yunnanyihe.oss-cn-heyuan.aliyuncs.com/2025/02/25/85a33fb7-77aa-405a-a1ac-658630adba5e.png'
              }
						},
						err => {
							this.$message.error(err)
						})	
      },
      // 获取项目位置信息
      getGardenAddress(id) {
        this.$get(`/gardensById?gardenId=` + id).then(
						res => {
              console.log(res)
              if (res.list.length > 1) {
                this.showBigDataScreen = false
                this.bigDataScreen = ''
                return
              }
              if (res.list[0].id && res.list[0].longitude && res.list[0].latitude) {
                this.showBigDataScreen = true
                // this.bigDataScreen = 'https://b.datav.run/share/page/f6c1017bf170c08088d0151896131deb?zoom=18&gardenID=' + res.list[0].id + '&lng=' + res.list[0].longitude + '&lat=' + res.list[0].latitude
                this.bigDataScreen = 'https://b.datav.run/share/page/3606e89edc05c134d21f3d9050fb3813?zoom=18&gardenID=' + res.list[0].id + '&lng=' + res.list[0].longitude + '&lat=' + res.list[0].latitude
              } else {
                this.showBigDataScreen = true
                // this.bigDataScreen = 'https://b.datav.run/share/page/f6c1017bf170c08088d0151896131deb?gardenID=' + res.list[0].id
                this.bigDataScreen = 'https://b.datav.run/share/page/3606e89edc05c134d21f3d9050fb3813?gardenID=' + res.list[0].id
              }
						},
						err => {
							this.$message.error(err)
						})	
      },
      // 获取数据大屏权限
      getBigDataScreen() {
        this.$get(`/getJobStaffByStaffId`).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              if (res.showDataV == 1) {
                this.showDataV = true
              } else {
                this.showDataV = false
              }
            }
          },
          error => {
            this.$message.error(error)
          })
      }

    }
  }
</script>

<style lang="scss">
  @import '../style/mixin.scss';

  .header_container {
    .el-dropdown {
      color: black;
    }

    width: 100%;
    // background-color: #EFF2F7;
    height: 40px;
    display: flex;
    float: left;
    align-items: center;
    padding-left: 20px;
    background-color: white;
    margin-bottom: 10px;

    .userMessage {
      cursor: pointer;
    }

    .fullScreen {
      cursor: pointer;
      color: black;
    }

    .el-dropdown-menu__item {
      text-align: center;
    }

    .el-dropdown-menu {
      z-index: 9999 !important;
    }

    .rightPostiton {
      color: black;
    }

    .blue_green {
      height: 20px;
      width: 20px;
      background-color: #00b1c3;
      margin: 10px;
      cursor: pointer;
      border-radius: 6px;
    }

    .pink {
      height: 20px;
      width: 20px;
      background-color: #c84b71;
      margin: 10px;
      cursor: pointer;
      border-radius: 6px;
    }

    .green {
      height: 20px;
      width: 20px;
      background-color: #4ea00b;
      margin: 10px;
      cursor: pointer;
      border-radius: 6px;
    }

    .click2 {
      margin: 20px;
    }

    .click4 {
      position: absolute;
      right: 30px;
    }
  }
</style>